// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import constants from "@store/constants";

export const getBlogSimilarArticlesDataView = (
    state: ApplicationState,
    quantity: number,
    cacheInvalidationId?: string,
) => {
    const currentPage = getCurrentPage(state);

    return getDataView(state.data.pages, {
        nodeId: currentPage.nodeId,
        quantity,
        type: constants.blog.getDataViewType.similarArticles,
        cacheInvalidationId,
    });
};
